import React, { useMemo, useState } from 'react';
import useStyles from './useStyles';
import CalendarIcon from '@material-ui/icons/CalendarTodayOutlined';
import CalendarV2 from '../../CalendarV2';
import { format } from 'date-fns';
import { Popover } from './styled';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useDateSettingsFormat } from 'common/useDateSettingsFormat';
import { PickerField } from 'lib';

export default ({ value, onChange = () => null }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const { fullDayDateSettingsFormat } = useDateSettingsFormat();
  const formattedValue = useMemo(
    () => (value ? format(new Date(value), fullDayDateSettingsFormat) : '-'),
    [value]
  );

  const handleChange = (e) => {
    onChange(e);
  };

  const handleClickDay = (clickedDay) => {
    if (clickedDay) setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <PickerField
        icon={<CalendarIcon />}
        open={!!anchorEl}
        onClick={(e) => setAnchorEl((el) => (el ? null : e.currentTarget))}
      >
        {formattedValue}
      </PickerField>
      <Popover
        open={!!anchorEl}
        elevation={0}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <CalendarV2
            value={value ? new Date(value) : new Date()}
            onChange={handleChange}
            onClickDay={handleClickDay}
            onClose={() => setAnchorEl(null)}
            maxDate={new Date()}
          />
        </ClickAwayListener>
      </Popover>
    </div>
  );
};
